import script from "./ManualProg.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualProg.vue?vue&type=script&setup=true&lang=js"

import "./ManualProg.vue?vue&type=style&index=0&id=333921fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-333921fa"]])

export default __exports__